import { createStore } from "redux";

import data from "./appsQuestion.json";
import resultData from "./appsResult.json";
import dataRecommend from "./appsRecommend.json";
import dataRecommendSet from "./appsRecommendSet.json";


const initialState = {
  count:0,
  datas:data,
  resultDatas:resultData,
  datasRecommend:dataRecommend,
  datasRecommendSet:dataRecommendSet,
  sum:0
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "ADD_SUM":
      return{
        ...state,
        sum:action.payload
      }
    case "ADD_COUNT":
      return{
        ...state,
        count:action.payload
      }
    default:
      return state;
  }
};

const store = createStore(reducer);

export default store;
